
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2.962","y":"9.318","width":"9.539","height":"9.539","rx":"1.908","fill":"#fff"}}),_c('rect',{attrs:{"x":"17.5","y":"25.655","width":"9.539","height":"9.539","rx":"1.908","transform":"rotate(-90 17.5 25.655)","fill":"#fff","fill-opacity":".65"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.5 10.15c0 1.054.854 1.908 1.907 1.908h5.724a1.908 1.908 0 001.907-1.908V4.427a1.908 1.908 0 00-1.907-1.908h-5.724A1.908 1.908 0 0017.5 4.427v5.723zm3.937-2.419l2.296-2.294a.638.638 0 01.902.903l-2.838 2.838a.509.509 0 01-.72 0l-1.174-1.174a.639.639 0 11.903-.904l.631.631z","fill":"#fff"}}),_c('path',{attrs:{"fill":"#B4BCCF","d":"M15.025 6.283h2.474v1.431h-2.474zM12.501 13.611h2.474v1.431h-2.474z"}}),_c('rect',{attrs:{"x":"14.31","y":"15.041","width":"8.759","height":"1.431","rx":".715","transform":"rotate(-90 14.31 15.041)","fill":"#B4BCCF"}})])
          )
        }
      }
    